const ajaxURL = adminurl.ajaxurl;

$(function(){

    $('.js-open-ticket, .js-ticket-back').on('click', function(){
        const dataID = $(this).data('id');
        $('#tickets').toggle();
        $('#leaveComment').toggle();
        $('.js-support-ticket[data-id="'+ dataID +'"]').toggleClass('hide');
    });

    $('.js-raise-new, .js-raise-new-back').on('click', function(){
        const dataID = $(this).data('id');
        $('#tickets').toggle();
        $('#submitTicket').toggle();
    });

    $('.js-filter-tickets').on('click', function(){
        const dataValue = $(this).data('value');
        console.log(dataValue);
        $('.js-status-filter').addClass('hide');
        $('.js-status-filter[data-status="'+ dataValue +'"]').toggleClass('hide');

    });

    $('.js-close-ticket').on('click', function(){
        var dataID = $(this).data('id');

        var data = {
            action: 'support_ticket_close',
            id: dataID
        }

        // Here is the ajax petition.
        jQuery.ajax({
            url : ajaxURL, // Here goes our WordPress AJAX endpoint.
            type : 'post',
            data : data,
            success : function( success ) {

                window.location.reload();

            },
            fail : function( err ) {
                // You can craft something here to handle an error if something goes wrong when doing the AJAX request.
                alert( "There was an error: " + err );
            }
        });
    })

})